import CampaignIcon from 'components/material-symbol/icons/Campaign'
import CelebrationIcon from 'components/material-symbol/icons/Celebration'
import CloudIcon from 'components/material-symbol/icons/Cloud'
import FavoriteIcon from 'components/material-symbol/icons/Favorite'

// Starter messages for the Message step. Text in [brackets] is for the coach
// to fill in; the Review step flags any that are left. Paragraphs are
// separated by a blank line and list items by a line break, as the message
// editor saves them.
export const MESSAGE_TEMPLATES = [
  {
    id: 'new-program',
    title: 'New Program Announcement',
    icon: CampaignIcon,
    body: [
      "I'm excited to share that registration is now open for [Program Name]!",
      "Whether you're looking to improve your game, build confidence, or just have fun, this program is a great opportunity to get out and play.",
      'Details:',
      '- When: [Date & Time]\n- Where: [Location]\n- Cost: [Price]',
      "Spots are limited, so be sure to register soon. I'd love to see you there!",
    ].join('\n\n'),
  },
  {
    id: 'weather-cancellation',
    title: 'Weather Cancellation',
    icon: CloudIcon,
    body: [
      "Due to the weather, I've made the decision to cancel [Lesson/Program Name] scheduled for [Date & Time].",
      "I'm sorry for the inconvenience! I'll be in touch with details about rescheduling.",
      'Thanks for your understanding, and I look forward to seeing you back on the course soon!',
    ].join('\n\n'),
  },
  {
    id: 'holiday',
    title: 'Holiday Message',
    icon: CelebrationIcon,
    body: [
      'As the year comes to a close, I wanted to take a moment to thank you for being part of my coaching community.',
      "It's been a pleasure being part of your golf journey this year, and I'm looking forward to even more progress, great swings, and time on the course together next year!",
      'Wishing you and your family a wonderful holiday season!',
    ].join('\n\n'),
  },
  {
    id: 'end-of-season',
    title: 'End-of-Season Thank You',
    icon: FavoriteIcon,
    body: [
      'As the golf season wraps up, I wanted to say thank you for another great year!',
      "I've really enjoyed working with you and being part of your progress on the course.",
      "Even though the season is winding down, it's never too early to start thinking about your goals for next year. I'd love to help you keep building on everything you've accomplished!",
      'Thanks again for a great season!',
    ].join('\n\n'),
  },
]
